module.exports = __webpack_public_path__ + "static/media/logo.551f9ba5.svg";